/* SafeS Pay Shopify A-site embedded checkout.
 * This file is generated for one B-site/store. Re-download it after changing the B-site.
 */
window.__SafeSPayEmbeddedCheckoutConfig = {
  "forceDirectProxy": true,
  "useWrapperPage": false,
  "proxyPath": "/a/checkouts/a_index.html",
  "bSiteId": "66daeaa4-bd92-4561-bd83-52458243bbe5",
  "bsiteId": "66daeaa4-bd92-4561-bd83-52458243bbe5",
  "b_site_id": "66daeaa4-bd92-4561-bd83-52458243bbe5",
  "store": "piginto",
  "storeSlug": "piginto",
  "mallStoreOrigin": "https://nookstill.shop",
  "bSiteOrigin": "https://nookstill.shop",
  "mallLandingPage": "",
  "landingPage": "",
  "landing_page": "",
  "mallPaymentGatewayMode": "selected",
  "paymentGatewayMode": "selected",
  "mallPaymentGateways": [],
  "paymentGateways": [],
  "mallPaymentChannelIds": [
    "whop#whop-1791520003387"
  ],
  "paymentChannelIds": [
    "whop#whop-1791520003387"
  ],
  "payment_channel_ids": [
    "whop#whop-1791520003387"
  ],
  "mall_channel_ids": [
    "whop#whop-1791520003387"
  ],
  "mallPaymentChannelId": "whop#whop-1791520003387",
  "paymentChannelId": "whop#whop-1791520003387",
  "payment_channel_id": "whop#whop-1791520003387",
  "mall_channel_id": "whop#whop-1791520003387"
};

(function () {
  "use strict";
  // Retired positioning-only URLs must remain inert if Shopify caches an old script tag.
  try { if (document.currentScript && new URL(document.currentScript.src).searchParams.get("checkout_scroll") === "1") return; } catch (e) {}


  if (window.__SafeSPayEmbeddedACheckoutLoaded || window.__PigintoProductCheckoutLoaded) return;
  window.__SafeSPayEmbeddedACheckoutLoaded = true;
  window.__PigintoProductCheckoutLoaded = true;

  var CHECKOUT_WRAPPER_PATH = "/a/checkouts/a_index.html";
  var LEGACY_CHECKOUT_WRAPPER_PATH = "/pages/piginto-checkout";
  var CHECKOUT_PROXY_PATH = "/a/checkouts/a_index.html";
  var VERSION = "20261021-complete-embedded-sticky";
  var tiktokFunnel = typeof createEmbeddedTikTokFunnel === "function"
    ? createEmbeddedTikTokFunnel(window, document, readConfig)
    : { install: function () {}, checkout: function () {} };
  // 「点击结账」信标:买家在 A站点了结账/立即购买(触发跳转)时上报一次,埋点类型 a_checkout_click。
  // 用来量「点了却没到达我们结账页」的截流:点击数(a_checkout_click) vs 打开页数(other)/到达数(a_checkout)。
  // 走商城公开 tracking 端点(已放行 A站跨域);平台域名常量,若平台域名变了改这一行。
  var CLICK_TRACKING_ENDPOINT = "https://clampin.shop/api/tracking/pageview";
  var CLICK_BEACON_SESSION_KEY = "safespay.checkoutClickSid.v1";
  var checkoutClickBeaconFired = false;
  var ATTRIBUTION_STORAGE_KEY = "safespay.embeddedAttribution.v1";
  var ATTRIBUTION_PARAM_NAMES = [
    "gclid", "gbraid", "wbraid", "dclid", "msclkid", "gad_source", "gad_campaignid", "gad_campaign_id",
    "fbclid", "fbc", "fbp",
    "ttclid", "ttp",
    "utm_source", "utm_medium", "utm_campaign", "utm_id", "utm_term", "utm_content",
    "campaignid", "campaign_id"
  ];
  var cartCheckoutUrlCache = "";
  var cartCheckoutUrlPromise = null;
  var cartRewriteTimer = 0;
  var cartRevision = 0;
  var lastCartWarmAttempt = 0;
  var productDataRequests = {};
  var activeCheckoutButton = null;
  var checkoutAttempt = 0;

  function fetchCheckoutJson(url) {
    var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    var timer;
    var request = Promise.resolve().then(function () {
      return fetch(url, {
        credentials: "same-origin", headers: { "Accept": "application/json" },
        signal: controller ? controller.signal : undefined
      });
    }).then(function (response) {
      if (!response.ok) throw new Error("checkout_http_" + response.status);
      return response.json();
    });
    var timeout = new Promise(function (resolve, reject) {
      timer = setTimeout(function () {
        reject(new Error("checkout_timeout"));
        if (controller) controller.abort();
      }, 12000);
    });
    return Promise.race([request, timeout]).then(function (value) {
      clearTimeout(timer); return value;
    }, function (error) { clearTimeout(timer); throw error; });
  }

  // The downloadable script must also work in themes without a Liquid data snippet.
  // Scope the lookup to the clicked product (quick views must not use the main product).
  function productJsonUrl(root) {
    var candidate = root && root.getAttribute && (root.getAttribute("data-url") || root.getAttribute("data-product-url"));
    var node = root && root.querySelector && root.querySelector("[data-product-url],product-info[data-url],a[href*='/products/']");
    if (!candidate && node) candidate = node.getAttribute("data-product-url") || node.getAttribute("data-url") || node.getAttribute("href");
    var url;
    try { url = new URL(candidate || window.location.href, window.location.origin); }
    catch (error) { return ""; }
    if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return "";
    url.pathname = url.pathname.replace(/\/$/, "") + ".js";
    url.search = ""; url.hash = "";
    return url.toString();
  }

  function dataMatchesProduct(data, root) {
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return false;
    var id = selectedVariantId(null, root);
    return !id || data.variants.some(function (variant) { return String(variant.id) === id; });
  }

  function resolveProductData(root) {
    var data = readData();
    if (dataMatchesProduct(data, root)) return Promise.resolve(data);
    var url = productJsonUrl(root);
    if (!url) return Promise.reject(new Error("checkout_product_missing"));
    if (!productDataRequests[url]) {
      productDataRequests[url] = fetchCheckoutJson(url).then(function (product) {
        if (!product || !Array.isArray(product.variants) || !product.variants.length) throw new Error("checkout_product_missing");
        return {
          productId: product.id, productTitle: product.title,
          productImageUrl: product.featured_image || product.images && product.images[0] || "",
          currency: currencyCode(null),
          variants: product.variants.map(function (variant) {
            return {
              id: variant.id, sku: variant.sku || String(variant.id), title: variant.title,
              price: variant.price, available: variant.available,
              imageUrl: variant.featured_image && variant.featured_image.src || product.featured_image || ""
            };
          })
        };
      }).catch(function (error) { delete productDataRequests[url]; throw error; });
    }
    return productDataRequests[url].then(function (resolved) {
      if (!dataMatchesProduct(resolved, root)) throw new Error("checkout_variant_missing");
      return resolved;
    });
  }

  function readJsonNode(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  function readConfig() {
    var globalConfig = window.__SafeSPayEmbeddedCheckoutConfig;
    if (globalConfig && typeof globalConfig === "object" && !globalConfig.nodeType) return globalConfig;
    return readJsonNode("SafeSPayEmbeddedCheckoutConfig") || readJsonNode("PigintoProductCheckoutConfig") || {};
  }

  function readData() {
    return readJsonNode("SafeSPayEmbeddedCheckoutData") || readJsonNode("PigintoProductCheckoutData");
  }

  function configuredBsiteId(data) {
    var config = readConfig();
    return String(
      data && (data.bSiteId || data.bsiteId || data.b_site_id) ||
      config.targetBSiteId ||
      config.targetBsiteId ||
      config.bSiteId ||
      config.bsiteId ||
      config.b_site_id ||
      ""
    ).trim();
  }

  function configuredStore(data) {
    var config = readConfig();
    return String(
      data && (data.store || data.storeSlug || data.targetStore) ||
      config.store ||
      config.storeSlug ||
      config.targetStore ||
      ""
    ).trim();
  }

  function configuredMallLandingPage(data) {
    var config = readConfig();
    return String(
      data && (data.mallLandingPage || data.landingPage || data.landing_page || data.bSiteLandingPage) ||
      config.mallLandingPage ||
      config.landingPage ||
      config.landing_page ||
      config.bSiteLandingPage ||
      ""
    ).trim();
  }

  function normalizeGatewayList(value) {
    var raw = Array.isArray(value) ? value : String(value || "").split(/[,，\s]+/);
    var seen = {};
    return raw.map(function (item) {
      return String(item || "").trim().toLowerCase();
    }).filter(function (item) {
      if (!item || seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function configuredMallPaymentGateways() {
    // Resolve payment routing from the A-site configuration on the checkout server.
    return [];
  }

  function normalizeChannelIdList(value) {
    var raw = Array.isArray(value) ? value : String(value || "").split(/[,，\s]+/);
    var seen = {};
    return raw.map(function (item) {
      return String(item || "").trim();
    }).filter(function (item) {
      if (!item || seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function configuredMallPaymentChannelIds() {
    // Resolve payment routing from the A-site configuration on the checkout server.
    return [];
  }

  function configuredMallPaymentChannelId(data) {
    return configuredMallPaymentChannelIds(data)[0] || "";
  }

  function configuredMallPaymentGatewayMode() {
    // Resolve payment routing from the A-site configuration on the checkout server.
    return "inherit";
  }

  function configuredASiteDomain() {
    var config = readConfig();
    return String(
      config.aSiteDomain ||
      config.configuredASiteDomain ||
      config.configured_a_site_domain ||
      window.location.hostname ||
      ""
    ).trim();
  }

  function cookieValue(name) {
    var target = String(name || "") + "=";
    var parts = String(document.cookie || "").split("; ");
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(target) === 0) return decodeURIComponent(parts[i].slice(target.length));
    }
    return "";
  }

  function normalizeAttributionAliases(result) {
    var aliases = {
      utm_source: "utmSource",
      utm_medium: "utmMedium",
      utm_campaign: "utmCampaign",
      utm_id: "utmId",
      utm_term: "utmTerm",
      utm_content: "utmContent",
      gad_source: "gadSource",
      gad_campaignid: "gadCampaignId",
      gad_campaign_id: "gadCampaignId",
      campaignid: "campaignId",
      campaign_id: "campaignId"
    };
    Object.keys(aliases).forEach(function (key) {
      var target = aliases[key];
      if (result[key] && !result[target]) result[target] = result[key];
    });
    return result;
  }

  function cleanAttributionObject(input) {
    var out = {};
    Object.keys(input || {}).forEach(function (key) {
      if (!key || key.charAt(0) === "_") return;
      var value = input[key];
      if (value === undefined || value === null || String(value) === "") return;
      out[key] = String(value).trim().slice(0, key === "sourceUrl" || key === "landingPage" || key === "referrer" ? 2000 : 1000);
    });
    return normalizeAttributionAliases(out);
  }

  function safeReadStoredAttribution() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY);
      if (!raw) return {};
      return cleanAttributionObject(JSON.parse(raw));
    } catch (error) {
      return {};
    }
  }

  function safeWriteStoredAttribution(value) {
    try {
      if (!window.localStorage) return;
      var clean = cleanAttributionObject(value);
      if (!hasAttributionSignal(clean)) return;
      clean._savedAt = new Date().toISOString();
      window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(clean));
    } catch (error) {
      // Browser privacy settings can block storage; checkout still carries current-page params.
    }
  }

  function hasAttributionSignal(input) {
    var data = input || {};
    return ATTRIBUTION_PARAM_NAMES.some(function (key) { return Boolean(data[key]); }) ||
      Boolean(
        data.utmSource || data.utmMedium || data.utmCampaign || data.utmId || data.utmTerm || data.utmContent ||
        data.gadSource || data.gadCampaignId || data.campaignId
      );
  }

  function currentAttributionParams() {
    var result = {};
    var params = new URL(window.location.href).searchParams;
    ATTRIBUTION_PARAM_NAMES.forEach(function (name) {
      var value = params.get(name);
      if (value) result[name] = value;
    });
    if (!result.fbp) result.fbp = cookieValue("_fbp");
    if (!result.fbc) result.fbc = cookieValue("_fbc");
    if (!result.ttp) result.ttp = cookieValue("_ttp");
    result.sourceUrl = window.location.href || "";
    result.referrer = document.referrer || "";
    result = cleanAttributionObject(result);
    if (hasAttributionSignal(result)) result.landingPage = result.landingPage || window.location.href || "";
    return result;
  }

  function collectAttributionParams() {
    var stored = safeReadStoredAttribution();
    var current = currentAttributionParams();
    var merged = cleanAttributionObject(Object.assign({}, stored, current));
    if (stored.landingPage && !hasAttributionSignal(current)) merged.landingPage = stored.landingPage;
    if (!merged.landingPage && hasAttributionSignal(merged)) merged.landingPage = current.sourceUrl || stored.sourceUrl || window.location.href || "";
    if (hasAttributionSignal(current) || hasAttributionSignal(stored)) safeWriteStoredAttribution(merged);
    return merged;
  }

  function publicAttributionParams(attribution) {
    var out = {};
    var aliases = {
      utmSource: "utm_source",
      utmMedium: "utm_medium",
      utmCampaign: "utm_campaign",
      utmId: "utm_id",
      utmTerm: "utm_term",
      utmContent: "utm_content",
      gadSource: "gad_source",
      gadCampaignId: "gad_campaignid",
      campaignId: "campaignid"
    };
    ATTRIBUTION_PARAM_NAMES.forEach(function (key) {
      if (attribution && attribution[key]) out[key] = attribution[key];
    });
    Object.keys(aliases).forEach(function (key) {
      var target = aliases[key];
      if (attribution && attribution[key] && !out[target]) out[target] = attribution[key];
    });
    return out;
  }

  function writeParams(url, params) {
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value !== undefined && value !== null && String(value) !== "") {
        url.searchParams.set(key, String(value));
      }
    });
  }

  function normalizePath(value, fallback) {
    var path = String(value || fallback || "").trim();
    if (!path) path = fallback || "/";
    if (path.charAt(0) !== "/") path = "/" + path;
    return path.replace(/\/+$/, "") || "/";
  }

  function checkoutWrapperPath(data) {
    var config = readConfig();
    return normalizePath(data && data.wrapperPath || config.wrapperPath, CHECKOUT_WRAPPER_PATH);
  }

  function checkoutProxyPath() {
    var config = readConfig();
    return normalizePath(config.proxyPath || config.baseUrl, CHECKOUT_PROXY_PATH);
  }

  function boolValue(value, fallback) {
    if (value === undefined || value === null || value === "") return fallback;
    if (value === true || value === false) return value;
    var text = String(value || "").trim().toLowerCase();
    if (!text) return fallback;
    if (text === "0" || text === "false" || text === "no" || text === "off") return false;
    if (text === "1" || text === "true" || text === "yes" || text === "on") return true;
    return fallback;
  }

  function forceDirectProxy(data) {
    var config = readConfig();
    var value = data && data.forceDirectProxy;
    if (value === undefined || value === null || value === "") value = config.forceDirectProxy;
    return boolValue(value, true);
  }

  function useWrapperPage(data) {
    if (forceDirectProxy(data)) return false;
    var config = readConfig();
    var value = data && data.useWrapperPage;
    if (value === undefined || value === null || value === "") value = config.useWrapperPage;
    if (value === undefined || value === null || value === "") value = config.wrapperMode;
    if (value === true) return true;
    value = String(value || "").trim().toLowerCase();
    return value === "page" || value === "wrapper" || value === "legacy";
  }

  function checkoutLandingPath(data) {
    return useWrapperPage(data) ? checkoutWrapperPath(data) : checkoutProxyPath();
  }

  function normalizeUrl(value) {
    var url = String(value || "").trim();
    if (!url) return "";
    if (url.indexOf("//") === 0) return window.location.protocol + url;
    if (url.charAt(0) === "/") return window.location.origin + url;
    return url;
  }

  function base64UrlEncode(text) {
    var bytes = new TextEncoder().encode(text);
    var binary = "";
    for (var i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  }

  function productForm(root) {
    return (root || document).querySelector('form[action*="/cart/add"]');
  }

  function selectedVariantId(data, root) {
    var form = productForm(root);
    var input = form && form.querySelector('[name="id"]') || (root || document).querySelector('[name="id"]');
    var fromBundle = selectedBundleVariantIds(root)[0] || "";
    var fromInput = input && input.value;
    var fromUrl = new URL(window.location.href).searchParams.get("variant");
    return String(fromBundle || fromInput || fromUrl || data && data.selectedVariantId || "");
  }

  function selectedVariant(data, root) {
    var variants = Array.isArray(data && data.variants) ? data.variants : [];
    var id = selectedVariantId(data, root);
    return variants.find(function (variant) {
      return String(variant.id) === id;
    }) || variants[0] || null;
  }

  function selectedQuantity(root) {
    var bundleQty = quantityFromBundle(root);
    if (bundleQty > 1) return bundleQty;

    var form = productForm(root);
    var input = form && form.querySelector('[name="quantity"]') || (root || document).querySelector('[name="quantity"]');
    var qty = Number(input && input.value || 0);
    return qty > 0 ? Math.floor(qty) : 1;
  }

  function quantityFromBundle(root) {
    var label = selectedQuantityBreak(root);
    var attrQty = Number(label && label.getAttribute && label.getAttribute("data-quantity") || 0);
    if (attrQty > 0) return Math.floor(attrQty);
    var text = label && (label.innerText || label.textContent) || "";
    var match = text.match(/buy\s*(\d+)/i) || text.match(/买\s*(\d+)/i);
    return match ? Number(match[1]) || 1 : 1;
  }

  function labelForInput(input, scope) {
    if (!input || !input.id || !scope || !scope.querySelectorAll) return null;
    var labels = scope.querySelectorAll("label");
    for (var i = 0; i < labels.length; i += 1) {
      if (labels[i].getAttribute("for") === input.id) return labels[i];
    }
    return null;
  }

  function elementText(node) {
    return node && (node.innerText || node.textContent || "") || "";
  }

  function looksLikeQuantityBreak(node) {
    var text = elementText(node);
    if (!text || !moneyCandidatesFromText(text).length) return false;
    return /buy\s*\d+|购买\s*\d+|bundle|save|you\s*save|quantity|套餐|件|pcs|折扣|节省/i.test(text);
  }

  function selectedQuantityBreak(root) {
    var scopes = [];
    if (root && root.querySelector) scopes.push(root);
    if (document && root !== document) scopes.push(document);
    for (var i = 0; i < scopes.length; i += 1) {
      var scope = scopes[i];
      var checked = scope.querySelector('quantity-breaks input[type="radio"][name="quantity"]:checked, input[type="radio"][name="quantity"]:checked');
      if (!checked) continue;
      var label = labelForInput(checked, scope) || labelForInput(checked, document) || checked.closest && checked.closest("label") || checked.nextElementSibling;
      var card = checked.closest && checked.closest("label, [data-quantity], .quantity-break, [class*='quantity'], [class*='bundle'], [class*='break'], [class*='offer']");
      var candidates = [label, card, checked.parentElement];
      for (var j = 0; j < candidates.length; j += 1) {
        var candidate = candidates[j];
        if (!candidate || !candidate.matches) continue;
        if (candidate.matches(".quantity-break, [data-quantity]") || candidate.querySelector(".quantity-break__price, [class*='quantity-break__price']") || looksLikeQuantityBreak(candidate)) return candidate;
      }
    }
    return null;
  }

  function selectedBundleVariantIds(root) {
    var label = selectedQuantityBreak(root);
    if (!label || !label.querySelectorAll) return [];
    var ids = [];
    var items = label.querySelectorAll("[data-selected-id], .quantity-break__selector-item");
    for (var i = 0; i < items.length; i += 1) {
      var id = String(items[i].getAttribute("data-selected-id") || "").trim();
      if (id) ids.push(id);
    }
    if (!ids.length) {
      var select = label.querySelector("[data-product-id]");
      var selectId = String(select && select.getAttribute("data-product-id") || "").trim();
      if (selectId) ids.push(selectId);
    }
    return ids;
  }

  function selectedBundleTotalCents(root) {
    var label = selectedQuantityBreak(root);
    if (!label || !label.querySelector) return 0;
    return bestPriceFromElement(label);
  }

  function closestTextBlock(node) {
    var block = node && node.closest("label, .bundle, .bundle-option, .option, .product-form__input, div");
    return block ? block.innerText || block.textContent || "" : "";
  }

  function variantTitle(data, variant) {
    var title = String(data && data.productTitle || "Item");
    var optionTitle = String(variant && variant.title || "").trim();
    if (optionTitle && optionTitle !== "Default Title") title += " - " + optionTitle;
    return title;
  }

  function currencyCode(data) {
    return data && data.currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "USD";
  }

  function payloadHasPricedItems(payload) {
    var items = Array.isArray(payload && payload.i) ? payload.i : [];
    return items.some(function (item) {
      return Number(item && item.qty || 0) > 0 && Number(item && item.price || 0) > 0;
    });
  }

  function checkoutUrlFromPayload(payload, source, data, options) {
    options = options || {};
    payload = payload && typeof payload === "object" ? payload : { c: "USD", i: [] };
    if (!payloadHasPricedItems(payload)) return "";
    var url = new URL(checkoutLandingPath(data), window.location.origin);
    var bSiteId = configuredBsiteId(data);
    var storeSlug = configuredStore(data);
    var mallLandingPage = configuredMallLandingPage(data);
    var mallPaymentGateways = configuredMallPaymentGateways(data);
    var mallPaymentChannelIds = configuredMallPaymentChannelIds(data);
    var mallPaymentChannelId = mallPaymentChannelIds[0] || "";
    var mallPaymentGatewayMode = configuredMallPaymentGatewayMode(data, mallPaymentGateways, mallPaymentChannelId);
    var currentUrl = options.sourceUrl || window.location.href || "";
    var returnUrl = options.returnUrl || currentUrl;
    var shopHost = window.location.hostname || "";
    var configuredDomain = configuredASiteDomain();
    var attribution = collectAttributionParams();
    if (bSiteId) {
      payload.bSiteId = payload.bSiteId || bSiteId;
      payload.bsiteId = payload.bsiteId || bSiteId;
      payload.b_site_id = payload.b_site_id || bSiteId;
      url.searchParams.set("bSiteId", bSiteId);
      url.searchParams.set("bsiteId", bSiteId);
      url.searchParams.set("b_site_id", bSiteId);
    }
    if (storeSlug) {
      payload.store = payload.store || storeSlug;
      payload.storeSlug = payload.storeSlug || storeSlug;
      url.searchParams.set("store", storeSlug);
    }
    if (mallLandingPage) {
      payload.mallLandingPage = payload.mallLandingPage || mallLandingPage;
      payload.landingPage = payload.landingPage || mallLandingPage;
      payload.landing_page = payload.landing_page || mallLandingPage;
      url.searchParams.set("mall_landing_page", mallLandingPage);
      url.searchParams.set("mallLandingPage", mallLandingPage);
      url.searchParams.set("landing_page", mallLandingPage);
      url.searchParams.set("landingPage", mallLandingPage);
    }
    if (mallPaymentGatewayMode && mallPaymentGatewayMode !== "inherit") {
      payload.mallPaymentGatewayMode = payload.mallPaymentGatewayMode || mallPaymentGatewayMode;
      payload.paymentGatewayMode = payload.paymentGatewayMode || mallPaymentGatewayMode;
      url.searchParams.set("mall_payment_gateway_mode", mallPaymentGatewayMode);
      url.searchParams.set("payment_gateway_mode", mallPaymentGatewayMode);
      url.searchParams.set("paymentGatewayMode", mallPaymentGatewayMode);
    }
    if (mallPaymentGateways.length) {
      payload.mallPaymentGateways = payload.mallPaymentGateways || mallPaymentGateways;
      payload.paymentGateways = payload.paymentGateways || mallPaymentGateways;
      url.searchParams.set("mall_payment_gateways", mallPaymentGateways.join(","));
      url.searchParams.set("payment_gateways", mallPaymentGateways.join(","));
      url.searchParams.set("paymentGateways", mallPaymentGateways.join(","));
    }
    if (mallPaymentChannelId) {
      payload.mallPaymentChannelIds = payload.mallPaymentChannelIds || mallPaymentChannelIds;
      payload.paymentChannelIds = payload.paymentChannelIds || mallPaymentChannelIds;
      payload.payment_channel_ids = payload.payment_channel_ids || mallPaymentChannelIds;
      payload.mall_channel_ids = payload.mall_channel_ids || mallPaymentChannelIds;
      payload.mallPaymentChannelId = payload.mallPaymentChannelId || mallPaymentChannelId;
      payload.paymentChannelId = payload.paymentChannelId || mallPaymentChannelId;
      payload.payment_channel_id = payload.payment_channel_id || mallPaymentChannelId;
      payload.mall_channel_id = payload.mall_channel_id || mallPaymentChannelId;
      url.searchParams.set("mall_channel_ids", mallPaymentChannelIds.join(","));
      url.searchParams.set("mallPaymentChannelIds", mallPaymentChannelIds.join(","));
      url.searchParams.set("payment_channel_ids", mallPaymentChannelIds.join(","));
      url.searchParams.set("paymentChannelIds", mallPaymentChannelIds.join(","));
      url.searchParams.set("mall_channel_id", mallPaymentChannelId);
      url.searchParams.set("mallPaymentChannelId", mallPaymentChannelId);
      url.searchParams.set("payment_channel_id", mallPaymentChannelId);
      url.searchParams.set("paymentChannelId", mallPaymentChannelId);
      url.searchParams.set("channel_id", mallPaymentChannelId);
    }
    payload.source = Object.assign({}, payload.source || {}, {
      type: "shopify_embedded_checkout",
      source: source || "shopify_theme",
      shop: shopHost,
      sourceUrl: currentUrl,
      returnUrl: returnUrl,
      aSiteDomain: shopHost,
      configuredASiteDomain: configuredDomain,
      openMode: "iframe",
      bSiteId: bSiteId,
      forceDirectProxy: forceDirectProxy(data),
      mallLandingPage: mallLandingPage,
      paymentGatewayMode: mallPaymentGatewayMode,
      paymentGateways: mallPaymentGateways,
      paymentChannelIds: mallPaymentChannelIds,
      paymentChannelId: mallPaymentChannelId
    });
    payload.attribution = Object.assign({}, attribution, payload.attribution || {});
    payload.adParams = Object.assign({}, attribution, payload.adParams || {});
    writeParams(url, publicAttributionParams(attribution));
    writeParams(url, {
      currency: payload.c || "USD",
      embed: "shopify",
      start: "top",
      source: source || "shopify_theme",
      shop: shopHost,
      source_url: currentUrl,
      return_url: returnUrl,
      a_site_domain: shopHost,
      configured_a_site_domain: configuredDomain,
      open_mode: "iframe",
      force_direct_proxy: forceDirectProxy(data) ? "1" : "0",
      landing: useWrapperPage(data) ? "wrapper" : "proxy"
    });
    url.searchParams.set("v", VERSION);
    url.searchParams.set("payload", base64UrlEncode(JSON.stringify(payload)));
    return url.toString();
  }

  function checkoutUrlFromProductData(data, root, options) {
    options = options || {};
    var variant = selectedVariant(data, root);
    if (!variant) return "";
    var qty = selectedQuantity(root);
    var bundleTotalCents = selectedBundleTotalCents(root);
    var bundleVariantIds = selectedBundleVariantIds(root);
    var domTotalCents = bundleTotalCents || priceFromDom(root);
    var variantCents = priceValueToCents(variant.price);
    var totalCents = domTotalCents || (variantCents && qty > 0 ? variantCents * qty : 0);
    var unitCents = totalCents && qty > 0
      ? Math.max(1, Math.round(totalCents / qty))
      : variantCents;
    if (!unitCents) return "";
    var variants = Array.isArray(data && data.variants) ? data.variants : [];
    var lineMap = {};
    var lineOrder = [];
    var ids = bundleVariantIds.length ? bundleVariantIds.slice(0, qty) : [String(variant.id || "")];
    while (ids.length < qty) ids.push(ids[0] || String(variant.id || ""));
    ids.forEach(function (id) {
      var lineVariant = variants.find(function (item) {
        return String(item.id) === String(id);
      }) || variant;
      var key = String(lineVariant.id || id || "item");
      if (!lineMap[key]) {
        lineMap[key] = {
          sku: lineVariant.sku || String(lineVariant.id || key || "item"),
          vid: String(lineVariant.id || ""),
          pid: String(data.productId || ""),
          title: variantTitle(data, lineVariant),
          qty: 0,
          price: unitCents,
          imageUrl: normalizeUrl(lineVariant.imageUrl || data.productImageUrl)
        };
        lineOrder.push(key);
      }
      lineMap[key].qty += 1;
    });
    var payload = {
      c: currencyCode(data),
      i: lineOrder.map(function (key) {
        return lineMap[key];
      })
    };
    if (totalCents) {
      payload.subtotalCents = totalCents;
      payload.amountCents = totalCents;
      payload.bundleQuantity = qty;
      payload.bundleUnitCents = unitCents;
      payload.priceSource = bundleTotalCents ? "bundle_dom" : (domTotalCents ? "dom_price" : "shopify_variant");
    }
    return checkoutUrlFromPayload(payload, options.sourceName || "shopify_theme_product", data, options);
  }

  function checkoutUrlFromCartData(cart, options) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var lines = items.map(function (item) {
      var variantTitleText = String(item.variant_title || "").trim();
      var title = String(item.product_title || item.title || "Item").trim();
      if (variantTitleText && variantTitleText !== "Default Title" && title.indexOf(variantTitleText) === -1) {
        title += " - " + variantTitleText;
      }
      return {
        sku: item.sku || String(item.variant_id || item.id || "shopify-item"),
        vid: String(item.variant_id || item.id || ""),
        pid: String(item.product_id || ""),
        title: title,
        qty: Math.max(1, Math.floor(Number(item.quantity || 1))),
        price: Number(item.final_price || item.price || 0),
        imageUrl: normalizeUrl(item.image || item.featured_image && item.featured_image.url || "")
      };
    }).filter(function (item) {
      return item.qty > 0;
    });
    if (!lines.length) return "";
    return checkoutUrlFromPayload({
      c: cart.currency || currencyCode(null),
      i: lines
    }, "shopify_theme_cart", readData() || {}, options);
  }

  function fetchCartCheckoutUrl(options) {
    return fetchCheckoutJson("/cart.js").then(function (cart) {
      return checkoutUrlFromCartData(cart, options);
    });
  }

  function cachedCartCheckoutUrl() {
    if (cartCheckoutUrlCache) return Promise.resolve(cartCheckoutUrlCache);
    if (cartCheckoutUrlPromise) return cartCheckoutUrlPromise;
    var revision = cartRevision;
    cartCheckoutUrlPromise = fetchCartCheckoutUrl().then(function (url) {
      if (revision !== cartRevision) return "";
      cartCheckoutUrlCache = url || "";
      cartCheckoutUrlPromise = null;
      return cartCheckoutUrlCache;
    }).catch(function (error) {
      if (revision === cartRevision) cartCheckoutUrlPromise = null;
      throw error;
    });
    return cartCheckoutUrlPromise;
  }

  function warmCartCheckoutUrl() {
    if (Date.now() - lastCartWarmAttempt < 2000) return;
    lastCartWarmAttempt = Date.now();
    cachedCartCheckoutUrl().then(function (url) {
      if (url) rewriteCartCheckoutControls();
    }).catch(function () {});
  }

  function invalidateCartCheckoutUrl() {
    cartRevision += 1;
    cartCheckoutUrlCache = "";
    cartCheckoutUrlPromise = null;
  }

  function moneyCandidatesFromText(text) {
    var matches = String(text || "").match(/(?:[$€£]|USD|CAD|AUD|EUR|GBP)\s*[0-9][0-9,]*(?:[.,][0-9]{1,2})?|[0-9][0-9,]*[.,][0-9]{2}/ig);
    if (!matches || !matches.length) return [];
    return matches.map(function (match) {
      var clean = String(match).replace(/[^0-9.,]/g, "");
      if (!clean) return 0;
      if (clean.indexOf(",") >= 0 && clean.indexOf(".") >= 0) {
        clean = clean.replace(/,/g, "");
      } else {
        clean = clean.replace(",", ".");
      }
      var value = Number(clean);
      return value > 0 ? Math.round(value * 100) : 0;
    }).filter(function (value) {
      return value > 0;
    });
  }

  function parseMoneyToCents(text) {
    var candidates = moneyCandidatesFromText(text);
    return candidates[0] || 0;
  }

  function stripSavingsText(text) {
    var amount = "(?:[$€£]|USD|CAD|AUD|EUR|GBP)?\\s*[0-9][0-9,]*(?:[.,][0-9]{1,2})?";
    return String(text || "")
      .replace(new RegExp("(?:you\\s*)?(?:save|saved|saves|saving)[^$€£0-9]*(?:" + amount + ")", "ig"), " ")
      .replace(new RegExp("(?:您节省了?|节省|省下?|省|优惠|折扣)[^$€£0-9]*(?:" + amount + ")", "ig"), " ")
      .replace(/\d+\s*%\s*(?:off|折扣)/ig, " ");
  }

  function smallestMoneyToCents(text) {
    var candidates = moneyCandidatesFromText(stripSavingsText(text)).sort(function (a, b) {
      return a - b;
    });
    return candidates[0] || 0;
  }

  function isCompareOrSavingsNode(node) {
    if (!node) return false;
    if (node.closest && node.closest("s, del, strike")) return true;
    var marker = [
      node.className,
      node.id,
      node.getAttribute && node.getAttribute("aria-label"),
      node.getAttribute && node.getAttribute("data-testid"),
      elementText(node)
    ].filter(Boolean).join(" ").toLowerCase();
    return /compare|regular|was-price|old-price|original|strike|save|saving|you save|discount|off|节省|折扣|原价/.test(marker);
  }

  function bestPriceFromElement(root) {
    if (!root || !root.querySelectorAll) return 0;
    var selectors = [
      ".quantity-break__price",
      "[class*='quantity-break'][class*='price']",
      "[class*='bundle'][class*='price']",
      "[data-final-price]",
      "[data-sale-price]",
      "[data-price]",
      ".price-item--sale",
      ".price__sale .price-item",
      ".money",
      "[class*='price']"
    ].join(",");
    var values = [];
    var nodes = root.querySelectorAll(selectors);
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (isCompareOrSavingsNode(node)) continue;
      var attrValue = node.getAttribute && (node.getAttribute("data-final-price") || node.getAttribute("data-sale-price") || node.getAttribute("data-price"));
      var attrCents = priceValueToCents(attrValue);
      if (attrCents) values.push(attrCents);
      var textCents = smallestMoneyToCents(elementText(node));
      if (textCents) values.push(textCents);
    }
    if (values.length) {
      values.sort(function (a, b) {
        return a - b;
      });
      return values[0] || 0;
    }
    return smallestMoneyToCents(elementText(root));
  }

  function priceValueToCents(value) {
    if (value === undefined || value === null || value === "") return 0;
    if (typeof value === "number") {
      if (!isFinite(value) || value <= 0) return 0;
      if (Math.round(value) !== value || value < 100) return Math.round(value * 100);
      return Math.round(value);
    }

    var text = String(value || "").trim();
    if (!text) return 0;
    var clean = text.replace(/[^0-9.,-]/g, "").replace(",", ".");
    var numeric = Number(clean);
    if (!isFinite(numeric) || numeric <= 0) return 0;
    if (/[$€£]|[.,]\d{1,2}\b/.test(text) || numeric < 100) return Math.round(numeric * 100);
    return Math.round(numeric);
  }

  function contextFromButton(button) {
    return button.closest('[role="dialog"], dialog, .modal, .quick-add-modal, .quick-view, .drawer, section, main') || document.body;
  }

  function titleFromDom(root) {
    var node = root.querySelector("[data-product-title], .product__title, .product-title, h1, h2, h3");
    var text = node && (node.innerText || node.textContent || "").trim();
    if (text && !/bundle|save|description|share/i.test(text)) return text;
    return (document.title || "Shopify item").replace(/\s*[|-].*$/, "").trim() || "Shopify item";
  }

  function imageFromDom(root) {
    var img = root.querySelector("img");
    return normalizeUrl(img && (img.currentSrc || img.src || img.getAttribute("src")) || "");
  }

  function priceFromDom(root) {
    var bundleCents = selectedBundleTotalCents(root);
    if (bundleCents) return bundleCents;
    var checked = root.querySelector('input[type="radio"]:checked');
    var checkedCard = checked && (checked.closest && checked.closest("label, [class*='quantity'], [class*='bundle'], [class*='break'], [class*='offer']"));
    var cents = bestPriceFromElement(checkedCard);
    if (cents) return cents;
    return bestPriceFromElement(root);
  }

  function checkoutUrlFromDom(root) {
    var qty = selectedQuantity(root);
    var totalCents = priceFromDom(root);
    var unitCents = qty > 1 && totalCents ? Math.round(totalCents / qty) : totalCents;
    if (!unitCents) return "";
    var variantId = selectedVariantId(null, root);
    var payload = {
      c: currencyCode(null),
      i: [{
        sku: variantId || "shopify-item",
        vid: variantId || "",
        title: titleFromDom(root),
        qty: qty,
        price: unitCents || 0,
        imageUrl: imageFromDom(root)
      }]
    };
    if (totalCents) {
      payload.subtotalCents = totalCents;
      payload.amountCents = totalCents;
      payload.priceSource = "dom_price";
    }
    return checkoutUrlFromPayload(payload, "shopify_quick_buy", readData() || {});
  }

  function injectStyle() {
    if (document.getElementById("PigintoProductCheckoutStyle")) return;
    var style = document.createElement("style");
    style.id = "PigintoProductCheckoutStyle";
    style.textContent = [
      // Embedded stores route every payment through the embedded checkout, so Shopify's native
      // express / dynamic checkout buttons (Shop Pay, PayPal express, etc.) must never be reachable:
      // their clicks happen inside a cross-origin iframe and cannot be intercepted, so hide them.
      ".shopify-payment-button,.shopify-payment-button__button,.dynamic-checkout__content,[data-shopify='dynamic-checkout-cart'],.additional-checkout-buttons{display:none!important;}",
      ".piginto-product-checkout-shell{width:100%;max-width:1280px;margin:28px auto 0;background:#fff;clear:both;}",
      ".piginto-product-checkout-shell iframe{display:block;width:100%;min-height:1250px;border:0;background:#fff;}",
      ".piginto-checkout-wrapper{width:100%;max-width:1280px;margin:0 auto;background:#fff;}",
      ".piginto-checkout-wrapper iframe{display:block;width:100%;height:1800px;min-height:1350px;border:0;background:#fff;}",
      ".safes-embedded-checkout-frame-wrap{position:relative;min-height:760px;background:#fff;}",
      ".safes-checkout-transition-mask{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.72);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);font:600 15px/1.4 -apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;color:#172033;}",
      ".safes-checkout-transition-card{display:flex;gap:12px;align-items:center;background:#fff;border:1px solid #e5e7eb;border-radius:12px;box-shadow:0 18px 48px rgba(15,23,42,.18);padding:16px 20px;}",
      ".piginto-product-checkout-message{padding:14px;border:1px solid #dbe3ef;border-radius:8px;background:#fff;color:#172033;font:14px/1.5 -apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;}",
      "body.piginto-checkout-theme-page .announcement-bar,body.piginto-checkout-theme-page .announcement-bar-section,body.piginto-checkout-theme-page [id*='announcement'],body.piginto-checkout-theme-page header nav,body.piginto-checkout-theme-page header .header__inline-menu,body.piginto-checkout-theme-page header .header__menu,body.piginto-checkout-theme-page header .menu,body.piginto-checkout-theme-page header .menu-list,body.piginto-checkout-theme-page header .header__drawer,body.piginto-checkout-theme-page header .header__search,body.piginto-checkout-theme-page header .header__icon--search,body.piginto-checkout-theme-page header .header__icon--account,body.piginto-checkout-theme-page header a[href*='/search'],body.piginto-checkout-theme-page header a[href*='/account'],body.piginto-checkout-theme-page header button[aria-label*='Search'],body.piginto-checkout-theme-page header button[aria-label*='搜索'],body.piginto-checkout-theme-page header button[aria-label*='Account'],body.piginto-checkout-theme-page header button[aria-label*='账户']{display:none!important;}",
      "body.piginto-checkout-theme-page .shopify-section-group-header-group,body.piginto-checkout-theme-page header{border-bottom:1px solid #d9d9d9!important;}",
      "body.piginto-checkout-theme-page header{min-height:72px!important;}",
      "body.piginto-checkout-theme-page header .header,body.piginto-checkout-theme-page header .header__inner,body.piginto-checkout-theme-page header .header-wrapper,body.piginto-checkout-theme-page header .page-width{display:flex!important;align-items:center!important;justify-content:space-between!important;}",
      "body.piginto-checkout-theme-page header .header__heading,body.piginto-checkout-theme-page header .header__heading-link,body.piginto-checkout-theme-page header .site-header__logo,body.piginto-checkout-theme-page header .header-logo{display:flex!important;align-items:center!important;}",
      "body.piginto-checkout-theme-page header .header__icons,body.piginto-checkout-theme-page header .site-header__icons{display:flex!important;align-items:center!important;margin-left:auto!important;}",
      "body.piginto-checkout-theme-page header .header__icons > *:not(.header__icon--cart):not([href*='/cart']):not(cart-icon):not(cart-drawer-opener){display:none!important;}",
      "body.piginto-checkout-theme-page footer,body.piginto-checkout-theme-page .footer,body.piginto-checkout-theme-page [id*='shopify-section-footer'],body.piginto-checkout-theme-page [id*='footer'],body.piginto-checkout-theme-page .shopify-section-group-footer-group,body.piginto-checkout-theme-page .footer-group,body.piginto-checkout-theme-page [class*='footer'],body.piginto-checkout-theme-page .scroll-to-top-btn,body.piginto-checkout-theme-page [id*='scroll-to-top']{display:none!important;}",
      "@media(max-width:749px){.piginto-product-checkout-shell{margin-top:22px}.piginto-product-checkout-shell iframe,.piginto-checkout-wrapper iframe{height:2200px;min-height:1550px;}}"
    ].join("");
    document.head.appendChild(style);
  }

  function insertAfter(reference, node) {
    if (!reference || !reference.parentNode) {
      (document.querySelector("main") || document.body).appendChild(node);
      return;
    }
    reference.parentNode.insertBefore(node, reference.nextSibling);
  }

  function createMount() {
    var existing = document.getElementById("PigintoProductCheckout");
    if (existing) return existing;
    var mount = document.createElement("section");
    mount.id = "PigintoProductCheckout";
    mount.className = "piginto-product-checkout-shell";
    var form = productForm(document);
    var section = form && form.closest('[id^="shopify-section-"], .shopify-section, section');
    insertAfter(section || form, mount);
    return mount;
  }

  var lastUrl = "";
  var frame = null;

  function updateProductPageFrame() {
    var data = readData();
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return;

    var mount = createMount();
    var nextUrl = checkoutUrlFromProductData(data, document);
    if (!nextUrl) return;

    if (!frame || !frame.parentNode) {
      mount.textContent = "";
      frame = document.createElement("iframe");
      frame.title = "Secure Checkout";
      frame.loading = "eager";
      frame.allow = "payment *; clipboard-read; clipboard-write; fullscreen";
      frame.referrerPolicy = "no-referrer";
      mount.appendChild(frame);
    }

    if (nextUrl !== lastUrl) {
      lastUrl = nextUrl;
      frame.src = nextUrl;
    }
  }

  function isBuyNowButton(button) {
    if (!isButtonLikeAction(button)) return false;
    if (button.matches && button.matches("[data-safes-pay-buy-now]")) return true;
    if (button.matches && button.matches("[data-skip-cart-button]")) return true;
    var form = button.form || button.closest && button.closest("form");
    if (form && button.matches && button.matches("button[name='add'],button[type='submit'],input[type='submit'],sticky-atc button[form][type='button'],.sticky-atc button[form][type='button']") &&
        form.querySelector("input[name='id'][data-skip-cart='true']")) return true;
    var text = actionText(button);
    if (!text) return false;
    var className = String(button && button.className || "");
    return /立\s*即\s*购\s*买/i.test(text) ||
      /马\s*上\s*购\s*买/i.test(text) ||
      /立\s*刻\s*购\s*买/i.test(text) ||
      text.indexOf("buy now") !== -1 ||
      text.indexOf("buy it now") !== -1 ||
      text === "checkout" ||
      text.indexOf("express checkout") !== -1 ||
      className.indexOf("shopify-payment-button") !== -1 ||
      className.indexOf("buy-now") !== -1 ||
      className.indexOf("dynamic-checkout") !== -1;
  }

  function isButtonLikeAction(node) {
    if (!node || !node.matches) return false;
    if (node.matches("[data-safes-pay-buy-now], [data-safes-pay-button], [data-piginto-cart-checkout]")) return true;
    if (node.matches("button, input[type='submit'], input[type='button'], [role='button']")) return true;
    var className = String(node.className || "");
    return className.indexOf("shopify-payment-button") !== -1 ||
      className.indexOf("dynamic-checkout") !== -1 ||
      className.indexOf("buy-now") !== -1;
  }

  function isCartCheckoutButton(button) {
    if (!button) return false;
    var text = actionText(button);
    var name = String(button.getAttribute && button.getAttribute("name") || "").toLowerCase();
    var href = String(button.getAttribute && button.getAttribute("href") || "");
    var form = button.form || button.closest && button.closest("form");
    var action = String(form && form.getAttribute("action") || "");
    var cartContext = button.closest && button.closest("cart-drawer, cart-items, .cart-drawer, .drawer, .cart, .cart__footer, .cart__ctas, [id*='CartDrawer'], [class*='cart-drawer'], [class*='cart__'], form[action*='/cart']");
    var cartLike = /\/cart(?:$|[?#/])/i.test(window.location.pathname + "/") ||
      /\/cart(?:$|[?#/])/i.test(action) ||
      Boolean(cartContext);
    var checkoutLike = name === "checkout" ||
      /\/checkout(?:$|[?#/])/i.test(href) ||
      /checkout|check out|结账|去付款|立即结账|proceed to checkout/i.test(text);
    return cartLike && checkoutLike;
  }

  function isProductPurchaseContext(button, root) {
    var path = window.location.pathname || "";
    if (button && button.matches && button.matches("[data-safes-pay-buy-now]")) return true;
    var form = button && (button.form || button.closest && button.closest("form"));
    if (form && /\/cart\/add(?:$|[?#/])/i.test(String(form.getAttribute("action") || ""))) return true;
    var buyContext = button && button.closest && button.closest("product-form, .product-form, .shopify-payment-button, .product__info-container, .product__info-wrapper, [data-product-form], [data-section-type='product']");
    if (/\/products\//i.test(path) && buyContext) return true;
    return false;
  }

  function actionText(node) {
    if (!node) return "";
    var className = typeof node.className === "string" ? node.className : "";
    return [
      node.innerText,
      node.textContent,
      node.value,
      node.getAttribute && node.getAttribute("aria-label"),
      node.getAttribute && node.getAttribute("title"),
      node.getAttribute && node.getAttribute("name"),
      node.getAttribute && node.getAttribute("data-action"),
      node.getAttribute && node.getAttribute("data-testid"),
      node.getAttribute && node.getAttribute("data-button-text"),
      className,
      node.id
    ].filter(Boolean).join(" ").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function closestCheckoutAction(target) {
    var node = target && (target.nodeType === 1 ? target : target.parentElement);
    var taggedButton = node && node.closest && node.closest("[data-safes-pay-buy-now], [data-safes-pay-button], [data-piginto-cart-checkout]");
    if (taggedButton) return taggedButton;
    for (var depth = 0; node && node !== document.body && depth < 10; depth += 1, node = node.parentElement) {
      if (node.matches && node.matches("a")) {
        if (isCartCheckoutButton(node)) return node;
        continue;
      }
      if (!isButtonLikeAction(node)) continue;
      if (isBuyNowButton(node) || isCartCheckoutButton(node)) return node;
      return node;
    }
    return null;
  }

  function isCheckoutWrapperPage() {
    var path = window.location.pathname.replace(/\/+$/, "");
    return path === checkoutWrapperPath() || path === LEGACY_CHECKOUT_WRAPPER_PATH;
  }

  function checkoutFrameUrlFromCurrentPage() {
    var source = new URL(window.location.href);
    var target = new URL(checkoutProxyPath(), window.location.origin);
    source.searchParams.forEach(function (value, key) {
      target.searchParams.set(key, value);
    });
    target.searchParams.set("embed", "shopify");
    target.searchParams.set("start", "top");
    target.searchParams.set("v", VERSION);
    return target.toString();
  }

  function checkoutFrameUrlFromWrapperUrl(wrapperUrl) {
    if (!wrapperUrl) return "";
    var source = new URL(wrapperUrl, window.location.origin);
    var target = new URL(checkoutProxyPath(), window.location.origin);
    source.searchParams.forEach(function (value, key) {
      target.searchParams.set(key, value);
    });
    target.searchParams.set("embed", "shopify");
    target.searchParams.set("start", "top");
    target.searchParams.set("v", VERSION);
    return target.toString();
  }

  function currentWrapperSourceUrl() {
    var params = new URL(window.location.href).searchParams;
    return params.get("source_url") || params.get("return_url") || "";
  }

  function jsonNodeFromDocument(doc, id) {
    var node = doc && doc.getElementById && doc.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  function checkoutUrlFromSourceProductData(data, sourceUrl, sourceDoc) {
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return "";
    var variantId = "";
    try {
      variantId = new URL(sourceUrl, window.location.origin).searchParams.get("variant") || "";
    } catch (error) {}
    var enhancedData = Object.assign({}, data || {});
    if (variantId && !enhancedData.selectedVariantId) enhancedData.selectedVariantId = variantId;
    return checkoutUrlFromProductData(enhancedData, sourceDoc || document, {
      sourceName: "shopify_theme_product_fallback",
      sourceUrl: sourceUrl,
      returnUrl: sourceUrl
    });
  }

  function fetchSourceProductCheckoutFrameUrl() {
    var sourceUrl = currentWrapperSourceUrl();
    if (!sourceUrl) return Promise.resolve("");
    var parsed;
    try {
      parsed = new URL(sourceUrl, window.location.origin);
    } catch (error) {
      return Promise.resolve("");
    }
    if (parsed.origin !== window.location.origin) return Promise.resolve("");
    return fetch(parsed.toString(), {
      credentials: "same-origin",
      headers: { "Accept": "text/html,application/xhtml+xml" }
    }).then(function (response) {
      if (!response.ok) throw new Error("source_" + response.status);
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var data = jsonNodeFromDocument(doc, "SafeSPayEmbeddedCheckoutData") || jsonNodeFromDocument(doc, "PigintoProductCheckoutData");
      var wrapperUrl = checkoutUrlFromSourceProductData(data, parsed.toString(), doc);
      return checkoutFrameUrlFromWrapperUrl(wrapperUrl);
    }).catch(function () {
      return "";
    });
  }

  function checkoutFrameUrlForWrapperPage() {
    var current = new URL(window.location.href);
    if (current.searchParams.get("payload")) return Promise.resolve(checkoutFrameUrlFromCurrentPage());

    var sourceUrl = currentWrapperSourceUrl() || window.location.href;
    return fetchCartCheckoutUrl({ sourceUrl: sourceUrl, returnUrl: sourceUrl }).then(function (wrapperUrl) {
      return checkoutFrameUrlFromWrapperUrl(wrapperUrl);
    }).catch(function () {
      return "";
    }).then(function (frameUrl) {
      if (frameUrl) return frameUrl;
      return fetchSourceProductCheckoutFrameUrl();
    }).then(function (frameUrl) {
      return frameUrl || checkoutFrameUrlFromCurrentPage();
    });
  }

  function mountCheckoutWrapperPage() {
    document.body.classList.add("piginto-checkout-theme-page");
    document.title = "Secure Checkout";
    var main = document.querySelector("main") || document.body;
    var wrapper = document.createElement("section");
    wrapper.className = "piginto-checkout-wrapper";

    var frameWrap = document.createElement("div");
    frameWrap.className = "safes-embedded-checkout-frame-wrap";
    var frame = document.createElement("iframe");
    frame.title = "Secure Checkout";
    frame.loading = "eager";
    frame.allow = "payment *; clipboard-read; clipboard-write; fullscreen";
    frame.referrerPolicy = "no-referrer";
    frameWrap.appendChild(frame);
    wrapper.appendChild(frameWrap);

    checkoutFrameUrlForWrapperPage().then(function (url) {
      frame.src = url || checkoutFrameUrlFromCurrentPage();
    }).catch(function () {
      frame.src = checkoutFrameUrlFromCurrentPage();
    });
    window.addEventListener("message", function (event) {
      var data = event && event.data;
      if (event.source !== frame.contentWindow) return;
      if (data && (data.type === "safesEmbeddedCheckoutReady" || data.type === "pigintoCheckoutReady" || data.type === "checkoutReady")) {
        return;
      }
      if (!data || (data.type !== "pigintoCheckoutResize" && data.type !== "safesCheckoutResize")) return;
      var height = Math.max(900, Math.min(4000, Number(data.height) || 0));
      if (!height) return;
      frame.style.height = height + "px";
    });

    main.innerHTML = "";
    main.appendChild(wrapper);
  }

  var isRedirecting = false;
  var checkoutTransitionMask = null;

  function showCheckoutTransition(message) {
    // Overlay removed: the jump to the embedded checkout is fast and the checkout page
    // renders an instant server-side skeleton, so no "Preparing secure checkout" mask is needed.
    return;
  }

  function hideCheckoutTransition() {
    if (!checkoutTransitionMask) return;
    if (checkoutTransitionMask.parentNode) checkoutTransitionMask.parentNode.removeChild(checkoutTransitionMask);
    checkoutTransitionMask = null;
  }

  function checkoutClickSessionId() {
    var gen = "clk_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
    try {
      var existing = window.sessionStorage.getItem(CLICK_BEACON_SESSION_KEY);
      if (existing) return existing;
      window.sessionStorage.setItem(CLICK_BEACON_SESSION_KEY, gen);
      return gen;
    } catch (e) {
      return gen; // 隐私模式无 sessionStorage:退化成每次一个 id(仍能统计点击,只是不跨刷新去重)
    }
  }

  // 点了结账就上报 a_checkout_click(同会话只报一次,和 other/a_checkout 同口径去重)。keepalive 保证
  // 跳转发生也能发出;全 try/catch + catch()静默,绝不阻断跳转。
  function fireCheckoutClickBeacon() {
    if (checkoutClickBeaconFired) return;
    checkoutClickBeaconFired = true;
    try {
      var store = configuredStore(readData());
      if (!store) return;
      fetch(CLICK_TRACKING_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-tenant-id": store },
        body: JSON.stringify({
          sessionId: checkoutClickSessionId(),
          pageType: "a_checkout_click",
          pagePath: location.href,
          referrer: location.href
        }),
        keepalive: true,
        mode: "cors",
        credentials: "omit"
      }).catch(function () {});
    } catch (e) {}
  }

  function navigateToCheckout(url, message) {
    fireCheckoutClickBeacon();
    tiktokFunnel.checkout(url);
    window.location.assign(url);
  }

  function stopCheckoutEvent(event) {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
  }

  function setCartButtonBusy(button, busy) {
    if (!button || !button.setAttribute) return;
    if (busy) {
      button.setAttribute("aria-busy", "true");
      if (button.tagName === "BUTTON" || button.tagName === "INPUT") button.disabled = true;
    } else {
      button.removeAttribute("aria-busy");
      if (button.tagName === "BUTTON" || button.tagName === "INPUT") button.disabled = false;
    }
  }

  function showCheckoutError(button) {
    var parent = button && button.parentElement;
    if (!parent) return;
    var box = parent.querySelector(".safes-checkout-error");
    if (!box) {
      box = document.createElement("p");
      box.className = "safes-checkout-error";
      box.setAttribute("role", "alert");
      parent.appendChild(box);
    }
    box.textContent = "Unable to prepare checkout. Please check your selection and try again.";
  }

  function clearCheckoutError(button) {
    var box = button && button.parentElement && button.parentElement.querySelector(".safes-checkout-error");
    if (box) box.textContent = "";
  }

  function failCheckout(button, attempt) {
    if (attempt !== checkoutAttempt) return;
    isRedirecting = false;
    setCartButtonBusy(button, false);
    activeCheckoutButton = null;
    hideCheckoutTransition();
    showCheckoutError(button);
  }

  function redirectCartCheckout(button, event) {
    if (isRedirecting) return true;
    isRedirecting = true;
    stopCheckoutEvent(event);
    setCartButtonBusy(button, true);
    activeCheckoutButton = button;
    var attempt = ++checkoutAttempt;
    clearCheckoutError(button);
    showCheckoutTransition("Preparing secure checkout...");

    // Prefetch is only a hint: read the current cart on a real checkout click.
    fetchCartCheckoutUrl().then(function (url) {
      if (attempt !== checkoutAttempt) return;
      if (!url) throw new Error("checkout_cart_empty");
      navigateToCheckout(url);
    }).catch(function () {
      failCheckout(button, attempt);
    });
    return true;
  }

  function redirectFromButton(button, event) {
    if (!button) return false;
    if (isRedirecting) {
      stopCheckoutEvent(event);
      return true;
    }

    if (button.disabled || button.getAttribute("aria-disabled") === "true" || button.getAttribute("data-unavailable") === "true") return false;

    if (isCartCheckoutButton(button)) {
      return redirectCartCheckout(button, event);
    }

    if (!isBuyNowButton(button)) return false;

    var required = Number(button.getAttribute("data-required-fields") || 0);
    var valid = Number(button.getAttribute("data-valid-fields") || 0);
    if (required > valid) { stopCheckoutEvent(event); showCheckoutError(button); return true; }

    var root = contextFromButton(button);
    // Never fall through to the native Shopify checkout for a recognized buy button.
    // If we cannot resolve the product context or build the embedded checkout URL
    // (e.g. incomplete config / no payment channel), block the click instead of
    // letting the native checkout take over.
    if (!isProductPurchaseContext(button, root)) {
      stopCheckoutEvent(event);
      showCheckoutError(button);
      return true;
    }
    var data = readData();
    isRedirecting = true;
    stopCheckoutEvent(event);
    setCartButtonBusy(button, true);
    activeCheckoutButton = button;
    var attempt = ++checkoutAttempt;
    clearCheckoutError(button);
    function go(resolved) {
      if (attempt !== checkoutAttempt) return;
      var variant = selectedVariant(resolved, root);
      if (!variant || variant.available === false) throw new Error("checkout_variant_unavailable");
      var url = checkoutUrlFromProductData(resolved, root);
      if (!url) throw new Error("checkout_product_missing");
      navigateToCheckout(url, "Preparing secure checkout...");
    }
    if (dataMatchesProduct(data, root)) {
      try { go(data); } catch (error) { failCheckout(button, attempt); }
    } else {
      resolveProductData(root).then(go).catch(function () { failCheckout(button, attempt); });
    }
    return true;
  }

  function bindQuickBuyClicks() {
    function handleEvent(event) {
      var target = event.target;
      var button = closestCheckoutAction(target);
      redirectFromButton(button, event);
    }

    var activeCapture = { capture: true, passive: false };
    // A touch/press may turn into scrolling or cancellation; only a click is a purchase.
    window.addEventListener("click", handleEvent, activeCapture);

    document.addEventListener("submit", function (event) {
      var form = event.target;
      var action = String(form && form.getAttribute && form.getAttribute("action") || "");
      if (/\/cart\/add(?:$|[?#/])/i.test(action)) invalidateCartCheckoutUrl();
      var button = event.submitter || form && form.querySelector && form.querySelector("[name='checkout'], button[type='submit'], input[type='submit']");
      redirectFromButton(button, event);
    }, true);
  }

  function rewriteCartCheckoutControls() {
    var controls = document.querySelectorAll("a, button, input[type='submit'], input[type='button'], [role='button']");
    var found = false;
    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      if (!isCartCheckoutButton(control)) continue;
      found = true;
      control.setAttribute("data-piginto-cart-checkout", "1");
      if (control.tagName === "A") {
        control.setAttribute("href", cartCheckoutUrlCache || "#");
      }
      var form = control.form || control.closest && control.closest("form");
      if (form) form.setAttribute("data-piginto-cart-checkout", "1");
    }
    if (found && !cartCheckoutUrlCache && !cartCheckoutUrlPromise) warmCartCheckoutUrl();
  }

  function scheduleCartRewrite() {
    clearTimeout(cartRewriteTimer);
    cartRewriteTimer = setTimeout(function () {
      rewriteCartCheckoutControls();
      if (document.querySelector("[data-piginto-cart-checkout]")) warmCartCheckoutUrl();
    }, 80);
  }

  var pending = 0;
  function scheduleUpdate() {
    clearTimeout(pending);
    pending = setTimeout(function () {}, 120);
  }

  function init() {
    // Direct App Proxy checkout already contains its complete page. Never frame itself.
    var currentPath = window.location.pathname.replace(/\/+$/, "");
    if (forceDirectProxy() && currentPath === checkoutProxyPath()) return;
    try { tiktokFunnel.install(); } catch (e) {}
    injectStyle();
    if (isCheckoutWrapperPage()) {
      mountCheckoutWrapperPage();
      return;
    }
    bindQuickBuyClicks();
    rewriteCartCheckoutControls();
    if (/\/cart(?:$|[?#/])/i.test(window.location.pathname + "/")) warmCartCheckoutUrl();
    if (window.MutationObserver) {
      new MutationObserver(scheduleCartRewrite).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "open", "aria-hidden", "style"]
      });
    }
    document.addEventListener("change", scheduleUpdate, true);
    document.addEventListener("change", invalidateCartCheckoutUrl, true);
    document.addEventListener("input", function (event) {
      scheduleUpdate();
      if (event && event.target && String(event.target.getAttribute && event.target.getAttribute("name") || "").toLowerCase() === "quantity") {
        invalidateCartCheckoutUrl();
      }
    }, true);
    document.addEventListener("cart:updated", function () {
      invalidateCartCheckoutUrl();
      scheduleCartRewrite();
    });
    document.addEventListener("variant:change", scheduleUpdate);
    document.addEventListener("variantChange", scheduleUpdate);
    document.addEventListener("shopify:section:load", scheduleUpdate);
    window.addEventListener("popstate", scheduleUpdate);
    // 返回/前进(尤其浏览器 bfcache 把整页连同遮罩 DOM + isRedirecting 状态原样恢复)时,
    // 强制清掉离开前显示的"Preparing secure checkout"遮罩并复位,否则遮罩会卡死在产品落地页上。
    window.addEventListener("pageshow", function () {
      checkoutAttempt += 1;
      isRedirecting = false;
      setCartButtonBusy(activeCheckoutButton, false);
      activeCheckoutButton = null;
      invalidateCartCheckoutUrl();
      hideCheckoutTransition();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
